import { useMemo, useCallback } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { TableCell } from "@mui/material"
import { sortDirLabel } from "helpers/sorts"
import SortIcon from "components/sort-icon"

export default function ContributorsDetailsSorting({ id, label, align, sort, order }) {
  const activeSortingClassNames = useMemo(() => order.by === id && ({
    sorting: true,
    [order.dir]: true,
    absolute: order.abs,
  }), [id, order])

  const { sorting } = activeSortingClassNames

  const sortBy = useCallback(() => {
    return sort({ by: id, current: order })
  }, [id, sort, order])

  return (
    <TableCell
      align={align}
      className={classNames(activeSortingClassNames)}
      title={sortDirLabel(order)}
      onClick={sortBy}
    >
      {sorting && <SortIcon direction={order.dir} absolute={order.abs} /> }
      {label}
    </TableCell>
  )
}

ContributorsDetailsSorting.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  align: PropTypes.string,
  sort: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
}
